import axios from "axios";
import { apollo_api_url, sisi2_api_url, sisikong_url } from "..";
import type {
  QuotationRequestRQ,
  QuotationRequestSessionType,
} from "../../components/modals/NewQuotationRequestModal/definitions";

// const baseUrl = "http://localhost:8888/sophon-evo";
const baseUrl = `${sisikong_url}/sophon-evo`;

export function getQuotations({ token, params }: { token: string; params: any }) {
  return axios.get(`${apollo_api_url}/quotations/`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function createQuotationUploadMode({ file }: { file: File }) {
  const formData = new FormData();
  formData.append("file", file);

  const url = `${baseUrl}/api/v1/create-quotation-request/upload-mode`;
  return fetch(url, { method: "POST", body: formData });
}

export async function createQuotationChat({
  message,
  chat_session_uid,
}: {
  message: string;
  chat_session_uid: string;
}) {
  const url = `${baseUrl}/api/v1/quotation-request-chat`;
  return fetch(url, {
    method: "POST",
    body: JSON.stringify({ message, chat_session_uid }),
    headers: { "Content-Type": "application/json" },
  });
}

export function createQuotationV2({
  payload,
}: { payload: QuotationRequestRQ }): Promise<{ data: { session_id: string } }> {
  return axios.post(`${baseUrl}/api/v1/create-quotation-request`, payload);
}

export function pollQuotationRequest(
  session_id: string,
): Promise<{ data: QuotationRequestSessionType }> {
  return axios.get(`${baseUrl}/api/v1/quotation-request/${session_id}`);
}

export function submitQuotationRequest({
  session_id,
  token,
}: { session_id: string; token: string }): Promise<{
  data: {
    quotation_request_id: number;
    quotation_request_reference: string;
    session_id: string;
  };
}> {
  const headers = { Authorization: `Bearer ${token}` };

  const payload = { session_id };
  return axios.post(`${baseUrl}/api/v1/submit-quotation-request`, payload, { headers });
}

export function excludeService(
  session_id: string,
  service_id: string,
): Promise<{ data: { service_id: string; session_id: string } }> {
  return axios.post(`${baseUrl}/api/v1/exclude-service`, { session_id, service_id });
}

export function reIncludeService(
  session_id: string,
  service_id: string,
): Promise<{ data: { service_id: string; session_id: string } }> {
  return axios.post(`${baseUrl}/api/v1/reinclude-service`, { session_id, service_id });
}
